import { Dialog, DialogProps, IconButton, Typography } from "@mui/material"
import { ReactNode } from "react"
import CloseIcon from "reusable/icons/CloseIcon"
import styled from "styled-components"
import colors from "theme/colors"
import { StyledDividerH } from "theme/shared"

const StyledDialog = styled(Dialog)<{
  $backgroundColor: boolean
}>`
  .MuiDialog-paper {
    width: calc(100% - 40px);
    border-radius: 8px;
    background-color: ${(p) => p.theme.colors.white};
    padding: 20px;
    box-shadow: ${(p) => p.theme.boxShadows.cardShadow};
    max-width: 700px !important;
    max-height: calc(100vh - 40px);
    padding-left: 0px;
    ${(p) => p.theme.breakpoints.down("sm")} {
      padding-top: 25px;
    }
  }

  /* mobile size: */
  ${(p) => p.theme.breakpoints.down("sm")} {
    .MuiDialog-container {
      margin: auto;
    }
    .MuiDialog-paperScrollBody {
      margin: auto;
    }
  }
`

const StyledWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 60px);
  overflow: scroll;
  form {
    height: 100%;
  }
  ${(p) => p.theme.breakpoints.down("sm")} {
    padding-left: 20px;
  }
`

const StyledIconButton = styled(IconButton)`
  position: absolute;
  top: 2px;
  right: 2px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    top: -5px;
    right: 0px;
    padding: 5px;
  }
`

const StyledTitle = styled(Typography).attrs({ variant: "h2" })`
  text-align: center;
`
const StyledSubtitle = styled(Typography).attrs({ variant: "body1" })`
  text-align: center;
  max-width: 400px;
`

const StyledPopUpTop = styled.div<{ $hasChildren: boolean }>`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  /* if children */
  ${(p) => p.$hasChildren && "margin-bottom: 20px;"}
`

export type InformationPopUpProps = DialogProps & {
  open: boolean
  setOpen?: (value: boolean) => void
  onClose: () => void
  children?: ReactNode
  icon?: ReactNode
  title?: string
  text?: string
  className?: string
  backgroundColor?: boolean
  withDivider?: boolean
  subtitle?: string
}

const InformationPopUp = ({
  open,
  setOpen,
  onClose,
  children,
  icon,
  title,
  text,
  className,
  backgroundColor = true,
  withDivider = false,
  subtitle,
}: InformationPopUpProps) => {
  const handleClose = () => {
    if (setOpen) {
      setOpen(false)
    }
    if (onClose) {
      onClose()
    }
  }
  // todo change this based on new design with two titles
  return (
    <StyledDialog
      open={open}
      onClose={handleClose}
      scroll="paper"
      className={className}
      $backgroundColor={backgroundColor}
    >
      <StyledIconButton onClick={handleClose}>
        <CloseIcon width={35} height={35} />
      </StyledIconButton>
      <StyledWrapper>
        <StyledPopUpTop $hasChildren={children !== undefined || withDivider}>
          {icon}
          {subtitle && <StyledTitle>{subtitle}</StyledTitle>}
          {title && <StyledTitle>{title}</StyledTitle>}
          {text && <StyledSubtitle>{text}</StyledSubtitle>}
        </StyledPopUpTop>
        {withDivider && (
          <StyledDividerH
            $color={colors.darkGrey}
            $width={0.5}
            $radius={3}
            $mb="20px"
          />
        )}
        {children}
      </StyledWrapper>
    </StyledDialog>
  )
}

export default InformationPopUp
